module.exports = __webpack_public_path__ + "static/artboard4-bafe615427e7c8f520f68f743cdf8a10.png";